import AdminManagement from "../components/AdminManagement"
import { Paper, Typography, useTheme } from "@mui/material";

const AdminPage = (props: any) => {
    const theme = useTheme();
    return (
        <Paper 
          component={"main"} 
          className='off-white'
          sx={{backgroundColor: theme.palette.background.default}}
        >
            <nav className='sub'>
                <Typography variant="h6">
                    Manage Admins
                </Typography>
            </nav>
            <div className="container">
                <AdminManagement />
            </div>
        </Paper>
    )
}

export default AdminPage
